<template>
  <ul v-if="seriesList && seriesList.length" class="sListWrapper">
    <li class="sListElement" v-for="(s, s_idx) in seriesList" :key="s_idx">
      <a :href="getSeriesLink(s)">
        <div>{{ s.series_name }}</div>
      </a>
    </li>
  </ul>
</template>
<script>
import { formatString } from "../../assets/js/common";
export default {
  props: ["seriesList"],
  methods: {
    getSeriesLink(series) {
      let seriesName = series.sport_name + " " + series.series_name;
      return `/${formatString(seriesName)}-series-${series.series_code}`;
    }
  },
};
</script>